export const exportTabs = {
  "SEARCH_FROM_LINKEDIN": "Search from Linkedin",
  "PASTE_PROFILE_URLS": "Paste profile Urls",
  "UPLOAD_FILE": "Upload file",
};
